export default __webpack_public_path__ + "static/media/signature.c4fc1db7.png";